import { domainStates } from 'Features/bzSetupPopup/BzSetup.types'

export const PLUGIN_ADMIN_PARTIAL_URL = '/wp-admin/admin.php?page=cheq-essential-plugin-options'
export const WORDPRESS_PLUGIN_PARTIAL_URL =
  '/wp-admin/plugin-install.php?tab=plugin-information&plugin=cheq-essentials-go-to-market-security'
const pluginPageLinkStates = [
  domainStates.BZWPPluginDeactivated,
  domainStates.BZWPPluginActivated,
  domainStates.InitialActive,
  domainStates.PluginActivated,
]
export const getPluginUrl = (bzState?: number | null, domainAddress?: string) =>
  pluginPageLinkStates.includes(bzState as number)
    ? `//${domainAddress as string}${PLUGIN_ADMIN_PARTIAL_URL}`
    : `//${domainAddress as string}${WORDPRESS_PLUGIN_PARTIAL_URL}`
